import { gql } from '@apollo/client';

export const fetchEntitlementDetailsForOrderHistoryPPC = gql`
  query fetchEntitlementDetailsForOrderHistoryPPC($id: String, $transactionAccountId: String) {
    entitlementDetails(id: $id, filters: { transactionAccountId: $transactionAccountId }) {
      cloudSiteHostname
      cloudSiteId
    }
  }
`;
